import { FontSizes, FontWeights, NeutralColors } from '@fluentui/react';

var pivotStyles = {
    root: {
        textAlign: 'center',
        whiteSpace: 'pre-wrap'
    },
    text: {
        color: 'white',
        fontSize: FontSizes.size18
    },
    link: {
        margin: '0 12px',
        '&:hover': {
            backgroundColor: 'unset'
        },
        '&:active': {
            backgroundColor: 'unset'
        },
        '&:hover:active': {
            backgroundColor: 'unset'
        }
    },
    linkIsSelected: {
        '&::before': {
            transition: 'none',
            right: '0',
            left: '0',
            '&:hover': {
                right: '0',
                left: '0'
            }
        }
    }
};
var commandBarStyles = {
    root: {
        width: '183px',
        height: '55px',
        justifyContent: 'start',
        borderRadius: '6px',
        padding: '4px 8px'
    },
    rootHovered: {
        backgroundColor: NeutralColors.gray30
    },
    rootPressed: {
        backgroundColor: NeutralColors.gray30
    },
    icon: {
        color: NeutralColors.gray130
    },
    iconHovered: {
        color: NeutralColors.gray130
    },
    iconPressed: {
        color: NeutralColors.gray130
    },
    label: {
        fontSize: FontSizes.size14,
        fontWeight: FontWeights.semibold,
        textAlign: 'start',
        lineHeight: '20px'
    }
};
var linkStyles = {
    root: {
        textDecoration: 'underline',
        color: NeutralColors.white
    }
};

export { commandBarStyles, linkStyles, pivotStyles };
